import { useRef } from "react"

import Style from "./style"

import MainHeader from "widget/MainHeader"

import useGetAdvertiseDetail from "entity/advertise/useGetAdvertiseDetail"
import usePostImgUpload from "entity/util/usePostImgUpload"
import usePostImgListUpload from "entity/util/usePostImgListUpload"
import usePutAdvertise from "entity/advertise/usePutAdvertise"

import CStyle from "shared/style/commonStyle"
import ITStyle from "shared/style/inputTableStyle"
import DefaultButton from "shared/ui/DefaultButton"

const AdEdit = () => {
    const bannerImgInputRef = useRef()
    const mainImgInputRef = useRef()
    const urlRef = useRef()

    const [advertiseData] = useGetAdvertiseDetail()
    const [bannerImg, uploadBannerImgEvent, deleteBannerImg] = usePostImgUpload(advertiseData?.data?.banner_img)
    const [mainImgList, uploadMainImgEvent, deleteMainImg] = usePostImgListUpload(advertiseData?.data?.img_list, 10)
    const [postAdvertise] = usePutAdvertise(bannerImg, mainImgList, urlRef)

    const btnList = [
        {
            "label": "저장",
            "clickEvent": () => postAdvertise(),
            "deactive": false
        }
    ]

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <Style.AreaDiv>
                <h2>배너 이미지 첨부<span>*</span></h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 10MB 제한</p>
                    <p>16:9 비율의 이미지에 가장 최적화 되어 있습니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => bannerImgInputRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={bannerImgInputRef} onChange={uploadBannerImgEvent} style={{ display: "none" }} />

                <Style.ImgUploadDiv>
                    {bannerImg &&
                        <Style.ImgElement>
                            <button onClick={deleteBannerImg}>삭제</button>
                            <img src={bannerImg} onClick={() => window.open(bannerImg, "_blank")} />
                        </Style.ImgElement>
                    }
                </Style.ImgUploadDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>본문 이미지 첨부</h2>
                <CStyle.GuideDiv>
                    <p>jpg, png 이미지 | 각 10MB 제한 | 최대 50개 까지 첨부</p>
                    <p>이미지 비율 상관 없이 그대로 출력됩니다.</p>
                    <p>PDF 파일 등은 추출기를 이용해 개별 이미지로 올려 주세요.</p>
                    <p>최대 50개 제한이지만, 사용자의 데이터 사용량을 고려해 여러 개의 게시글로 나눠 작성하는 것을 권장합니다.</p>
                </CStyle.GuideDiv>
                <DefaultButton small fitWidth clickEvent={() => mainImgInputRef.current.click()}>첨부하기</DefaultButton>
                <input type="file" ref={mainImgInputRef} onChange={uploadMainImgEvent} style={{ display: "none" }} />

                {mainImgList.length > 0 &&
                    <Style.ImgUploadDiv>
                        {mainImgList?.map((elem, index) =>
                            <Style.ImgElement key={index}>
                                <button onClick={() => deleteMainImg(index)}>삭제</button>
                                <img src={elem} onClick={() => window.open(elem, "_blank")} />
                            </Style.ImgElement>
                        )}
                    </Style.ImgUploadDiv>
                }

            </Style.AreaDiv>

            <ITStyle.TableDiv>
                <ITStyle.TableVerticalElement>
                    <h2>연결 링크</h2>
                    <input ref={urlRef} placeholder="http 까지 포함된 유효한 URL 주소" defaultValue={advertiseData?.data?.url} />
                </ITStyle.TableVerticalElement>
            </ITStyle.TableDiv>

        </Style.Wrapper>
    )
}

export default AdEdit